var require_runtime = require('../../_virtual/_rolldown/runtime.cjs');
//#region src/types/plugins/ContainerReferencePlugin.ts
var ContainerReferencePlugin_exports = /* @__PURE__ */ require_runtime.__exportAll({});
//#endregion
Object.defineProperty(exports, 'ContainerReferencePlugin_exports', {
    enumerable: true,
    get: function get() {
        return ContainerReferencePlugin_exports;
    }
}); //# sourceMappingURL=ContainerReferencePlugin.cjs.map
